"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../utilities/index");
var index_2 = require("../styles/index");
exports.AnimationClassNames = index_1.buildClassMap(index_2.AnimationStyles);
//# sourceMappingURL=AnimationClassNames.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/icons/~/@uifabric/styling/lib/classNames/AnimationClassNames.js
// module id = ../node_modules/@uifabric/icons/node_modules/@uifabric/styling/lib/classNames/AnimationClassNames.js
// module chunks = 1